import {Campaign} from '../types/campaign.type';
import {createApiRequest} from '../api/api';

export default async function GetVoops(
  endpoint: string,
  token: any,
  userId: string,
  campaignId?: string,
): Promise<Campaign[]> {
  const headers = {
    Authorization: 'Bearer ' + token,
  };
  const data = await createApiRequest(
    null,
    headers,
    'GET',
    `${endpoint}/user/${userId}/campaign/${campaignId}/voops`,
  );
  return JSON.parse(data.body);
}
